require('./helpers/bundle-manifest').register(JSON.parse("{\"2BF4I\":\"index.21750e53.js\",\"2e9XJ\":\"logo.4378220f.png\",\"cfndr\":\"1lg.eac394db.png\"}"));